import React from "react";
const TrackingOfProgress = ({ image }) => {
  return (
    <div>
      <style>{`
        h3 {
          margin-top: 14px;
          margin-bottom: 2px;
        }
        th, td, tr {
          margin: -2px;
          border-collapse: collapse;
          paddingTop: -2px;
          border: 1px solid #181818;
          text-align: left;
          padding: 0px 3px;
          font-size: 13px;
        }
        table {
          border-collapse: collapse
        }  
      `}</style>
      <h3 className="table-heading">Tracking of Progress:</h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description / Specification</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>01.</td>
            <td> alpha.kryzen.com</td>
            <td>
              Once KBPL receives work order from you. Your client portal access
              is created by us. At client portal you get access to timeline of
              development, team working on your project, site inspection
              details, delivery of goods, track of progress, information of
              agronomist, etc.
            </td>
          </tr>
        </tbody>
      </table>
      {image != "visible" ? (
        <div
          style={{
            display: "flex",

            justifyContent: "center",
            width: "100%",
            marginTop: "12px",
          }}
        >
          <img
            src={
              "https://res.cloudinary.com/bsgfcooa/image/upload/v1753080646/hm2_y4twz3_phxi61_jrwuw1.png"
            }
            width={"80%"}
            alt="kryzenCertificates"
          />
        </div>
      ) : (
        ""
      )}
      {/* <div
        style={{
          position: "relative",
          bottom: "10px",
          right: "10px",
          fontSize: "14px",
          textAlign: "right",
        }}
      >
        3/38
      </div> */}
      {image != "visible" ? (
        <div
          className="html2pdf__page-break"
          style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
        ></div>
      ) : (
        ""
      )}
    </div>
  );
};

export default TrackingOfProgress;
